<template>
	<div class="wrap">
		<DelData ref="delDatas"></DelData>
		<!-- 评级弹窗 -->
		<Grade ref="grade" @dataList="dataList" :year="getdata.year"></Grade>
		<div class="navbar">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>组织生活</el-breadcrumb-item>
				<el-breadcrumb-item>{{$route.name}}</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="datawrap">
			<div class="treeWrap" v-if="$store.state.user.userinfo.flag!=3">
				<tree @treeSelect="treeSelect"></tree>
			</div>
			<div class="datatable">
				<div class="datas">
					<div class="selectbar">
						<div>
							<el-input
								style="margin-right: 10px; width: 200px !important;" 
								size="small"
								v-model="getdata.name" placeholder="姓名"
								@input="getdata.page = 1;totalPage = 0;dataList();"
								clearable>
							</el-input>
							<el-select
								size="small"
								style="margin-right: 10px;width: 100px !important;" 
								v-model="getdata.level" placeholder="等级"
								@change="getdata.page = 1;totalPage = 0;dataList();"
								clearable>
								<el-option
									label="优秀"
									value="4">
								</el-option>
								<el-option
									label="合格"
									value="3">
								</el-option>
								<el-option
									label="基本合格"
									value="2">
								</el-option>
								<el-option
									label="不合格"
									value="1">
								</el-option>
							</el-select>
							<el-select
								size="small"
								style="margin-right: 10px;width: 100px !important;" 
								v-model="getdata.year" placeholder="选择年份"
								@change="getdata.page = 1;totalPage = 0;dataList();">
								<el-option
									:key="item"
									v-for="item in $yearList()"
									:label="item"
									:value="item">
								</el-option>
							</el-select>
						</div>
						<div>
							<el-upload
								name="file"
								style="margin-right:10px;"
								:data="{
									dwid:this.$store.state.user.userinfo.dwid,
									token:$store.state.user.userinfo.token
								}"
								:action="$uploadFile"
								:show-file-list="false"
								multiple
								:limit="4"
								:on-success="success1"
								v-if="$store.state.user.userinfo.flag==1"
								:on-progress="uploadProcess"
								:before-upload="limitFiles">
								<el-button size="small" type="primary">文件上传</el-button>
							</el-upload>
						</div>
					</div>
					<div class="selectdata">
						<myTables 
							@selectEnable="selectEnable"
							:tableData="tableData"
							delkey="hyid"
                            :tableHeader="tableHeader"
                            :loading="true" 
							:indexs="false"
							:selection="false"></myTables>
						<Page :totalPage="totalPage" :pageSize="10" @changedata="changedata"></Page>
						<div class="dwfile" v-if="dwFlies.files.length>0">
							<div class="filelabel">附件：</div>
							<div class="files">
								<div class="file" :key="index" v-for="(item,index) in dwFlies.files">
									<div>{{item.title}}</div>
									<i class="el-icon-close" 
									@click="delDwFiles(item.id)" 
									v-if="$store.state.user.userinfo.flag==1"></i>
									<i class="el-icon-download"
									 @click="zbDownloadFile(item.url)"
									 v-else></i>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import indexs from './mixins/index'
	export default{
		mixins: [indexs],
	}
</script>

<style lang="scss" scoped="scoped">
	.wrap{
		position: relative;
		height: 100%;
		width: 100%;
		.fengmian {
		    height: 86px;
		    width: 150px;
			object-fit: cover;
		}
		.switchBar{
			width: 100%;
			height: 40px;
			line-height: 40px;
			margin-bottom: 20px;
			border-bottom: 1px solid #DDDDDD;
			span{
				cursor: pointer;
				display: inline-block;
				line-height: 40px;
				font-size: 16px;
				margin-right: 20px;
				padding: 0 20px;
				font-weight: bold;
			}
			span:hover{
				color: #BB0000;
				border-bottom: 2px solid #bb0000;
			}
			.selectSwitch{
				color: #BB0000;
				border-bottom: 2px solid #bb0000;
			}
		}
	}
</style>

